export default __webpack_public_path__ + "static/media/kg-no-regrets.ketch.38351614.ttf";